/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import { multiPoint as turfMultiPoint, circle as turfCircle } from '@turf/turf';
import utilityService from './utility.service';
import applicationDataSource from '../datasource/applicationdata.datasource';
import weatherImgService from './weather.service';
import bnChartDataService from './chartData.service';
import avwxService from '../views/Imagery/Imagery.service';

// function arrayMin(arr) {
//   return arr.reduce((p, v) => (p < v ? p : v));
// }

// function arrayMax(arr) {
//   return arr.reduce((p, v) => (p > v ? p : v));
// }

const bootstrapAppService = () => {
  const content = {};
  content.loadRequiredDataSource = async () => {
    // debugger
    const airportsListing = await bnChartDataService.getAirportsListing();
    const radarSiteListing = await bnChartDataService.getRadarSiteListing();
    // const tt = [];
    // airportsListing.forEach((aa) => {
    //   tt.push(aa.map_sort);
    //   console.log(aa.icao_id, ' : ', aa.map_sort);
    // });
    // console.log(arrayMin(tt), arrayMax(tt));
    applicationDataSource.airportsListing = airportsListing;
    applicationDataSource.radarSiteListing = radarSiteListing;
    const multiPoints = radarSiteListing.map((site) => [
      site.location[1],
      site.location[0],
      site.icao]);
    radarSiteListing.forEach((site) => {
      site.circleRadiusGeoJson = turfCircle(
        [site.location[1], site.location[0]],
        185.2,
        { steps: 10, units: 'kilometers' },
      );
    });
    utilityService.processAirportJson();
    applicationDataSource.radarSiteGeoJson = turfMultiPoint(multiPoints);
    applicationDataSource.radarSitePoints = multiPoints;
    weatherImgService.loadImagesObjMap();
    avwxService.getAvwxDataFromJson().then((avwxData) => {
      applicationDataSource.avwxData = avwxData;
    });
    return true;
  };
  return content;
};
export default bootstrapAppService();
